import React from 'react'
import styles from './SignupTourCaddieVerification.module.scss'
import SelfVerification from '../components/SelfVerification/SelfVerification'
import { useState } from 'react'
import ToggleButtonGroup from '../../../components/ToggleButtonGroup/ToggleButtonGroup'
import MembershipNumber from '../components/MembershipNumber/MembershipNumber'
import RegisterNoticeModal from '../components/modal/RegisterNoticeModal'
// import { certificationNice } from '../../../../utils/niceApi'
import { userTypes } from '../../../utils'
import { useForm, Controller } from 'react-hook-form'
import { useCallback, useEffect } from 'react'
import ToggleButtonGroupController from '../../../components/ToggleButtonGroup/ToggleButtonGroupController'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuthStatus } from '../../../utils'
import { useStateMachine } from 'little-state-machine'
import { updateStore } from '../../../store'
import { registerTourCaddie, signin } from '../../../services/api'

import axios from 'axios'
const returnURL = `${window.location.origin}/certify/complete`

const SignupTourCaddieVerfication = () => {
	const [verifiedStatus, setVerifiedStatus] = useState('notTried')
	const [submitType, setSubmitType] = useState(0)
	const [isModalOpened, setIsModalOpened] = useState(false)
	const location = useLocation()
	const [niceVerifiedUserInfo, setNiceVerifiedUserInfo] = useState(null)
	const navigate = useNavigate()
	const [auth, onChangeAuth] = useAuthStatus()

	// Store
	const { actions, state } = useStateMachine({ updateStore })
	const dataFromPrev = state.signupInput

	const {
		control,
		handleSubmit,
		register,
		watch,
		trigger,
		setValue,
		formState: { errors, isValid },
		clearErrors,
	} = useForm({
		mode: 'onSubmit', // 유효성 검사를 할 곳이 회원번호 5-8자리 보다 적게 입력하는 경우 말고 없음
		defaultValues: {
			// association: 'KLPGA',
			// memberNumber: '',
			name: '',
			phoneNumber: '',
		},
	})

	// 멤버 넘버를 제외한 유효성 검사를 위한 커스텀 함수
	const handleSubmitWithoutMemberNumber = useCallback(
		(onSubmit) => {
			return () => {
				// 현재 폼 데이터 가져오기
				const currentData = watch()

				// memberNumber를 제외한 필드들만 검증
				const { memberNumber, ...dataWithoutMemberNumber } = currentData

				// 필수 필드들이 모두 있는지 확인
				if (
					dataWithoutMemberNumber.name &&
					dataWithoutMemberNumber.phoneNumber
					// dataWithoutMemberNumber.association
				) {
					onSubmit(currentData)
				}
			}
		},
		[watch],
	)

	const onSubmitFinalData = async (data, typeNum) => {
		console.log('Final Form Data :', data)

		const phoneNumber = data.phoneNumber
		const cleanedPhoneNumber = phoneNumber.replace(/-/g, '')

		const finalSubmissionData = {
			name: data.name,
			gender: dataFromPrev.gender === 'male' ? 'MALE' : 'FEMALE',
			nationality: dataFromPrev.nationality === 'domestic' ? 'DOMESTIC' : 'FOREIGN',
			email: dataFromPrev.email,
			password: dataFromPrev.password,
			phone: cleanedPhoneNumber,
			notification: dataFromPrev.message,
			point: 0,
			userType: 'tourCaddie',
			profileType: 'unknown',
			caddieTeamName: dataFromPrev.caddieTeam || '',
			careerLevel: dataFromPrev?.proCareer,
		}
		console.log('최종데이터 : ', finalSubmissionData)

		try {
			const response = await registerTourCaddie(finalSubmissionData)
			console.log('API 응답 성공:', response)

			const isApproved = response.approval_status === 'approved'
			if (isApproved) {
				const signInResponse = await signin(dataFromPrev.email, dataFromPrev.password)
				console.log('자동 로그인 시도중')
				console.log(signInResponse.user)

				// 토큰과 사용자 정보 저장 (useAuthStatus 훅 사용)
				const { token, user } = signInResponse
				onChangeAuth(token, user)
				navigate('/onboarding/select-tournament')
			} else {
				console.log('가입 대기 중인 상태에요.')
				setIsModalOpened(true)
			}
		} catch (error) {
			console.error('API 요청 실패:', error)
			// 에러 응답 확인 (서버에서 보낸 에러 메시지 등)
			if (error.response) {
				console.error('응답 데이터:', error.response.data)
				console.error('응답 상태:', error.response.status)
				console.error('응답 헤더:', error.response.headers)
				alert(`회원가입 실패: ${error.response.data.message || '알 수 없는 오류'}`) // 사용자에게 에러 메시지 표시
			} else if (error.request) {
				// 요청이 전송되었지만 응답을 받지 못함 (예: 네트워크 오류)
				console.error('응답을 받지 못했습니다:', error.request)
				alert('네트워크 오류: 서버에 연결할 수 없습니다.')
			} else {
				// 요청 설정 중 오류 발생
				console.error('요청 설정 오류:', error.message)
				alert('요청 처리 중 오류가 발생했습니다.')
			}
		}
		// setIsModalOpened(false)
	}

	const handleVerificationSuccess = useCallback(
		(info) => {
			setValue('name', info.name)
			setValue('phoneNumber', info.phoneNumber)
			setVerifiedStatus('success')
		},
		[setValue],
	)

	const association = watch('association')
	const memberNumberValue = watch('memberNumber')

	const toggleOption = [
		{ value: 'KLPGA', label: 'KLPGA(여자)' },
		{ value: 'KPGA', label: 'KPGA(남자)' },
	]

	return (
		<div className={styles.container}>
			<form
				className={styles.mainForm}
				onSubmit={handleSubmit((data) => onSubmitFinalData(data, 3))}>
				<div className={styles.title}>투어캐디 회원가입</div>

				<SelfVerification
					verifiedStatus={verifiedStatus}
					changeVerifiedStatus={setVerifiedStatus}
					onVerificationSuccess={handleVerificationSuccess}
					noMarginTop={true}></SelfVerification>

				<div className={styles.buttonWrapper}>
					<div className={styles.buttonContainer}>
						<button
							className={styles.beforeButton}
							type="button"
							onClick={() => navigate(-1)}>
							이전
						</button>
						<button
							className={`${styles.nextButton} ${
								verifiedStatus !== 'success' ? styles.disabled : ''
							}`}
							type="submit"
							disabled={verifiedStatus !== 'success'}>
							완료
						</button>
					</div>
				</div>
				{isModalOpened && (
					<RegisterNoticeModal
						setSubmitType={setSubmitType}
						isOpen={isModalOpened}
						changeIsModalOpened={setIsModalOpened}
						onFormSubmit={handleSubmitWithoutMemberNumber} // 멤버 넘버를 제외한 유효성 검사
						onFinalDataSubmit={onSubmitFinalData}
						tourCaddie={true}></RegisterNoticeModal>
				)}
			</form>

			<div>
				{/*nice 서버에 submit할 form*/}
				<form
					name="form"
					id="form"
					action="https://nice.checkplus.co.kr/CheckPlusSafeModel/service.cb">
					<input type="hidden" id="m" name="m" value="service" />
					<input type="hidden" id="token_version_id" name="token_version_id" value="" />
					<input type="hidden" id="enc_data" name="enc_data" />
					<input type="hidden" id="integrity_value" name="integrity_value" />
					<input type="hidden" name="ReturnURL" value="" />
				</form>
			</div>
		</div>
	)
}

export default SignupTourCaddieVerfication
